import { render, staticRenderFns } from "./wlXq.vue?vue&type=template&id=674551b1&scoped=true"
import script from "./wlXq.vue?vue&type=script&lang=js"
export * from "./wlXq.vue?vue&type=script&lang=js"
import style0 from "./wlXq.vue?vue&type=style&index=0&id=674551b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674551b1",
  null
  
)

export default component.exports